import { styled, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

// others
import { formatCurrency } from '../../../utils'
import { FetchBillDetailsQuery, FetchPublicBillDetailsQuery } from '../../../../generated'
import { FC } from 'react'

type ProtectedBill = NonNullable<FetchBillDetailsQuery['fetchBillDetails']['bill']>
type PublicBill = NonNullable<FetchPublicBillDetailsQuery['fetchPublicBillDetails']['bill']>

interface FundRequestPreviewEntriesTableProps {
  bill: ProtectedBill | PublicBill
}

const CustomTable = styled(Table)(({ theme }) => ({
  minWidth: '600px',
  border: '1px solid #E0E0E0',
  '& .MuiTableCell-root': {
    padding: theme.spacing(1.5, 1),
    fontSize: '10px !important',
    backgroundColor: 'transparent'
  }
}))

const FundRequestPreviewEntriesTable: FC<FundRequestPreviewEntriesTableProps> = ({ bill }) => {
  const { description, amount } = bill

  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell width="70%">Notes</TableCell>
          <TableCell width="30%">Amount</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell sx={{ whiteSpace: 'pre-line' }}>{description}</TableCell>
          <TableCell>{formatCurrency(amount)}</TableCell>
        </TableRow>
      </TableBody>
    </CustomTable>
  )
}

export default FundRequestPreviewEntriesTable
